<template>
  <div class="real-time-review">
    <!-- 顶部基础信息 -->
    <div class="page-header">
      <div class="header-left">
        <el-button icon="el-icon-arrow-left" @click="handleBack" size="small" plain>
          返回
        </el-button>
        <i class="el-icon-s-order"></i>
        <div>
          <div class="header-title">评审结果查看</div>
          <div class="header-sub">标段编号: {{ finalBidSectionCode }}</div>
        </div>
      </div>
      <div class="header-right">
        <!-- 仅暗标生效 -->
        <el-button type="primary" icon="el-icon-document-copy" @click="handleCompareTable" size="small" plain
                   :loading="compareTableLoading" v-if = "isBlindReview">
          对照表格
        </el-button>

        <!-- 获取最新评审结果 -->
        <el-button type="success" icon="el-icon-refresh" @click="handleManualRefresh" size="small" plain
                   :loading="refreshLoading" v-if="!isEvaluationFinished">
          获取最新评审结果
        </el-button>


        <el-button v-if="!isEvaluationFinished" :type="isRealTime ? 'danger' : 'primary'"
                   :icon="isRealTime ? 'el-icon-video-pause' : 'el-icon-video-play'" @click="checkRealTime" size="small"
                   plain>
          {{ isRealTime ? '关闭实时刷新' : '开启实时刷新' }}

          <!-- 倒计时显示 -->
          <span v-if="isRealTime">
            <i class="el-icon-time"></i> {{ countdown }}s
          </span>
        </el-button>

      </div>
    </div>


    <div class="main-layout">
      <!-- 左侧：步骤列表 + 结果列表 -->
      <div class="left-panel" :class="{ collapsed: isLeftPanelCollapsed }">
        <!-- 步骤列表 -->
        <div class="panel-card step-list-card" v-show="!isLeftPanelCollapsed">
          <div class="panel-title">
            <span>评审步骤</span>
            <i class="el-icon-d-arrow-left collapse-icon" @click="toggleLeftPanel" title="折叠">折叠</i>
          </div>
          <div class="step-list-scroll">
            <div class="step-list">
              <div v-for="(step, index) in stepList" :key="step.id || index" class="step-item"
                   :class="{ active: currentStepIndex === index }" @click="handleStepClick(step, index)">
                <div class="step-index">{{ index + 1 }}</div>
                <div class="step-info">
                  <div class="step-name">{{ step.stepName }}</div>
                  <div class="step-type">{{ step.stepTypeName }}</div>
                </div>
                <div class="step-status">
                  <el-tag v-if="step.finished == -1" size="mini" type="info">未开始</el-tag>
                  <el-tag v-else-if="step.finished == 0" size="mini" type="warning">评审中</el-tag>
                  <el-tag v-else size="mini" type="success">已完成</el-tag>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 折叠状态下的展开按钮 -->
        <div class="collapsed-expand-btn" v-show="isLeftPanelCollapsed" @click="toggleLeftPanel" title="展开">
          <i class="el-icon-d-arrow-right"></i>
        </div>
      </div>

      <!-- 右侧：控制栏 + 专家列表 + 评审详情 -->
      <div class="right-panel">
        <!-- 控制栏：视图切换 -->
        <div class="panel-card control-card" v-if="currentStep && currentStep.finished >= 0">
          <div class="panel-body control-row">
            <span class="control-label">查看模式：</span>
            <!-- 只有通过式(01)和打分式(02)才显示切换选项 -->
            <el-radio-group v-if="needExpertSelection" v-model="viewMode" @change="handleViewModeChange" size="small">
              <el-radio-button label="detail">查看专家打分</el-radio-button>
              <el-radio-button label="summary">查看打分汇总</el-radio-button>
            </el-radio-group>
            <!-- 其他类型固定显示查看打分汇总 -->
            <el-tag v-else type="info" size="small" effect="plain" style="margin-right: 12px;">查看打分汇总</el-tag>

            <div class="status-indicator">
              <i class="el-icon-time" v-if="currentStep.finished == 0"></i>
              <i class="el-icon-circle-check" v-else></i>
              <span>{{ currentStep.finished == 0 ? '评审进行中' : '评审已结束' }}</span>
            </div>
          </div>
        </div>

        <!-- 专家列表（仅专家明细模式且需要时显示） -->
        <div class="panel-card expert-card" v-if="viewMode === 'detail' && needExpertSelection">
          <div class="panel-title">选择专家</div>
          <div class="panel-body expert-list">
            <div v-for="expert in expertList" :key="expert.id" class="expert-item"
                 :class="{ active: selectedExpertId === expert.id }" @click="selectExpert(expert)">
              <i class="el-icon-user-solid"></i>
              <span>{{ expert.realName || expert.name }}</span>
            </div>
            <el-empty v-if="expertListLoading" description="加载中..." :image-size="60"></el-empty>
            <el-empty v-if="!expertListLoading && expertList.length === 0" description="暂无专家数据"
                      :image-size="60"></el-empty>
          </div>
        </div>

        <!-- 评审详情(右侧展示) -->
        <div class="panel-card detail-card" :style="detailAreaHeight ? { height: detailAreaHeight + 'px' } : {}">
          <div class="panel-title">
            <span>评审详情</span>
            <!-- 打印按钮 -->
<!--            <el-button v-if="currentStep && currentStep.finished > 0 && resultData" size="mini" type="primary"-->
<!--                       icon="el-icon-printer" plain @click="handlePrint" style="float: right; margin-right: 10px;">打印结果-->
<!--            </el-button>-->
          </div>

          <div class="panel-body detail-body" v-loading="loading" ref="printArea">
            <div class="detail-content-scroll">
              <!-- 未开始状态 -->
              <div v-if="currentStep && currentStep.finished == -1" class="empty-tip">
                <i class="el-icon-lock"></i>
                <p>该评审步骤尚未开始</p>
              </div>

              <!-- 评审中状态：不显示结果，提示稍后查看（仅非打分式且非通过式的汇总模式下提示） -->
              <div
                v-else-if="currentStep && currentStep.finished == 0 && viewMode === 'summary' && !isScoreReview && !isPassReview"
                class="empty-tip">
                <i class="el-icon-time"></i>
                <p>当前步骤尚未评审完成，请稍后查看</p>
              </div>

              <!-- 专家明细模式未选专家 -->
              <div v-else-if="viewMode === 'detail' && needExpertSelection && !selectedExpertId" class="empty-tip">
                <i class="el-icon-pointer"></i>
                <p>请从上方专家列表中点击选择一位专家</p>
              </div>

              <!-- 有数据时展示详情 -->
              <template v-else-if="resultData">
                <div class="html-content" v-html="resultData.htmlContent"></div>
              </template>

              <!-- 空数据 -->
              <el-empty v-else description="暂无评审详情数据" :image-size="100"></el-empty>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 对照表格 -->
    <el-dialog title="暗标对照表格" :visible.sync="compareTableDialogVisible" width="60%" append-to-body
               :close-on-click-modal="false">
      <el-table v-if="comparisonTableData.length" :data="comparisonTableData" border style="width: 100%"
                v-loading="compareTableLoading">
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="blindName" label="暗标名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userName" label="投标单位名称" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <el-empty v-else description="暂无对照表格数据" :image-size="100"></el-empty>
    </el-dialog>
  </div>
</template>

<script>
import realTimeReviewApi from '@/api/modules/stepRealTimeReview'
import {getIsBlindByStepId} from '@/api/modules/base'

export default {
  name: 'RealTimeReviewPage',
  props: {
    bidSectionCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 优先使用路由参数，其次使用 props
      routeBidSectionCode: this.$route.query.bidSectionCode || '',
      stepList: [],
      currentStep: null,
      currentStepIndex: -1,

      // 左侧面板展开/折叠状态
      isLeftPanelCollapsed: false,

      isRealTime: false,
      countdown: 30,
      countdownTimer: null,
      refreshLoading: false,
      loading: false,
      expertListLoading: false,

      // 视图模式：detail-专家明细, summary-汇总
      viewMode: 'summary',
      expertList: [],
      selectedExpertId: null,

      resultData: null,
      supplierList: [],
      compareTableLoading: false,
      compareTableDialogVisible: false,
      comparisonTableData: []
    }
  },
  computed: {
    // 最终使用的标段编码（优先路由参数）
    finalBidSectionCode() {
      return this.routeBidSectionCode || this.bidSectionCode
    },
    // 是否需要专家列表（仅通过式01和打分式02需要）
    needExpertSelection() {
      if (!this.currentStep) return false
      const type = this.currentStep.stepTypeCode
      return type === '01' || type === '02'
    },
    isPassReview() {
      return this.currentStep && this.currentStep.stepTypeCode === '01'
    },
    isScoreReview() {
      return this.currentStep && this.currentStep.stepTypeCode === '02'
    },
    isBlindReview() {
      if (!this.currentStep) return false
      return Number(this.currentStep.isBlindReview) === 1
    },
    // 是否所有评审步骤已完成
    isEvaluationFinished() {
      if (!this.stepList || this.stepList.length === 0) {
        return false
      }
      // 判断是否所有步骤的 finished 都等于 1（已完成）
      return this.stepList.every(step => Number(step.finished) === 1)
    },
  },

  /**
   * created 改成 async
   * 等步骤列表加载完成后再决定是否开启轮询
   */
  async created() {
    await this.loadStepList()
    // 只有存在未完成步骤时才开启实时刷新
    if (!this.isEvaluationFinished) {
      this.startRealTime()
    }
  },
  watch: {
    /**
     * 统一处理“全部完成”
     */
    isEvaluationFinished: {
      handler(val) {
        if (val && this.isRealTime) {
          this.stopRealTimeRefresh()
          this.$message.info('所有评审步骤已完成，已自动停止实时刷新')
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.stopRealTimeRefresh()
  },
  methods: {
    /**
     * 1. 加载评审步骤列表
     */
    async loadStepList() {
      if (!this.finalBidSectionCode) return
      try {
        const res = await realTimeReviewApi.getReviewResultList(
          this.finalBidSectionCode
        )
        if (res.code === 200) {
          this.stepList = res.data || []
          // 首次进入
          if (this.stepList.length > 0 && this.currentStepIndex === -1) {
            const idx = this.stepList.findIndex(s => Number(s.finished) === 0)
            const targetIdx = idx >= 0 ? idx : 0
            this.handleStepClick(this.stepList[targetIdx], targetIdx)
          } else if (this.currentStepIndex >= 0) {
            /**
             * 防止 currentStepIndex 越界
             */
            if (this.currentStepIndex < this.stepList.length) {
              this.currentStep = this.stepList[this.currentStepIndex]
            } else {
              this.currentStep = null
              this.currentStepIndex = -1
            }
          }
        }
      } catch (e) {
        console.error('加载步骤列表失败', e)
      }
    },

    // 2. 点击步骤
    async handleStepClick(step, index) {
      this.currentStep = step
      this.currentStepIndex = index
      this.resultData = null
      this.supplierList = []

      // 重置右侧状态
      this.viewMode = 'summary' // 默认汇总
      this.selectedExpertId = null
      this.expertList = []
      // 非通过式/打分式
      if (!this.needExpertSelection) {
        this.viewMode = 'summary'
      }
      await this.loadReviewResult()
    },

    // 3. 视图模式切换
    async handleViewModeChange(mode) {
      this.viewMode = mode
      this.selectedExpertId = null
      this.resultData = null

      if (mode === 'detail' && this.needExpertSelection) {
        // 只有切到专家明细，且步骤需要专家时，才加载专家列表
        await this.loadExpertList()
      } else {
        this.expertList = []
        // 切换回汇总模式时，直接调用，内部会做拦截判断
        await this.loadReviewResult()
      }
    },

    // 4. 加载专家列表
    async loadExpertList() {
      if (!this.finalBidSectionCode) return
      this.expertListLoading = true
      try {
        const res = await realTimeReviewApi.getExpertList(this.finalBidSectionCode)
        if (res.code === 200) {
          this.expertList = res.data || []
          // 默认选中第一个专家（仅更新选中状态，不触发结果请求）
          if (this.expertList.length > 0) {
            this.selectedExpertId = this.expertList[0].id
            // 只要 finished >= 0 (即 0评审中 或 1已完成) 都可以加载该专家的结果
            if (this.currentStep && Number(this.currentStep.finished) >= 0) {
              this.loadReviewResult()
            }
          }
        }
      } catch (e) {
        console.error('加载专家列表失败', e)
        this.$message.error('加载专家列表失败')
      } finally {
        this.expertListLoading = false
      }
    },

    // 5. 选择专家
    selectExpert(expert) {
      this.selectedExpertId = expert.id
      // 只要 finished >= 0 (即 0评审中 或 1已完成) 都可以请求该专家的评审结果
      if (this.currentStep && Number(this.currentStep.finished) >= 0) {
        this.loadReviewResult()
      }
    },

    /**
     * 6. 加载评审结果
     */
    async loadReviewResult() {
      if (!this.currentStep) return
      const finished = Number(this.currentStep.finished)
      // 未开始
      if (finished === -1) return
      // 评审中且非打分/通过式
      if (finished === 0 && this.viewMode === 'summary' && !this.isScoreReview && !this.isPassReview) {
        return
      }
      this.loading = true
      try {
        const params = {
          stepId: this.currentStep.id,
          bidSectionCode: this.finalBidSectionCode,
          stepTypeCode:
          this.currentStep.stepTypeCode
        }
        // 专家明细
        if (this.viewMode === 'detail' && this.selectedExpertId) {
          params.expertId =
            this.selectedExpertId
        }
        const res =
          await realTimeReviewApi.getReviewResultDetail(params)
        if (res.code === 200) {
          this.resultData = res.data || {}
          this.extractSuppliers(this.resultData)
        } else {
          this.resultData = null
          this.$message.warning(res.msg || '获取结果失败')
        }
      } catch (e) {
        console.error('加载评审结果失败', e)
        this.resultData = null
      } finally {
        this.loading = false
      }
    },

    /**
     * 提取供应商
     */
    extractSuppliers(data) {
      if (!data) return
      if (data.suppliers) {
        this.supplierList = data.suppliers
      } else if (data.rows && data.rows.length > 0) {
        const keys = Object.keys(data.rows[0]).filter(k =>
          !['itemName', 'reviewItem', 'scoreItem', 'maxScore', 'fullScore', 'avgScore', 'summaryScore'].includes(k)
        )
        this.supplierList = keys.map((k, i) => ({supplierId: k, supplierName: `投标人${i + 1}`}))
      }
    },

    checkRealTime() {
      if (this.isRealTime) {
        this.stopRealTimeRefresh()
      } else {
        this.startRealTime()
      }
    },
    /**
     * startRealTime 增强保护
     */
    startRealTime() {
      // 没有步骤数据
      if (!this.stepList || this.stepList.length === 0) {
        return
      }
      // 全部完成
      if (this.isEvaluationFinished) {
        this.stopRealTimeRefresh()
        return
      }
      // 防止重复创建定时器
      if (this.countdownTimer) {
        return
      }
      this.isRealTime = true
      this.countdown = 30
      this.countdownTimer = setInterval(
        async () => {
          // 每次轮询前检查
          if (this.isEvaluationFinished) {
            this.stopRealTimeRefresh()
            return
          }
          this.countdown--
          if (this.countdown <= 0) {
            await this.doRefresh()
            this.countdown = 30
          }
        }, 1000)
    },
    /**
     * 清除定时器
     */
    clearCountdownTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
    /**
     * 停止实时刷新
     */
    stopRealTimeRefresh() {
      this.isRealTime = false
      this.clearCountdownTimer()
    },
    /**
     * 执行刷新
     */
    async doRefresh() {
      // 刷新前校验
      if (this.isEvaluationFinished) {
        this.stopRealTimeRefresh()
        return
      }
      // 刷新步骤
      await this.loadStepList()
      // 刷新后再次校验
      if (this.isEvaluationFinished) {
        this.stopRealTimeRefresh()
        return
      }
      // 请求详情
      if (this.currentStep && Number(this.currentStep.finished) >= 0) {
        await this.loadReviewResult()
      }
    },
    /**
     * 手动刷新
     */
    async handleManualRefresh() {
      this.refreshLoading = true
      try {
        await this.doRefresh()
        // 重置倒计时
        if (this.isRealTime) {
          this.countdown = 30
        }
      } finally {
        this.refreshLoading = false
      }
    },
    /**
     * 暗标对照表
     */
    async handleCompareTable() {
      if (!this.currentStep) {
        this.$message.warning('请先选择评审步骤')
        return
      }
      this.compareTableLoading = true
      try {
        const res = await getIsBlindByStepId(this.currentStep.id)
        if (res.code === 200) {
          const isBlind = res.data && res.data.blind
          if (isBlind) {
            await this.loadComparisonTable()
          } else {
            this.$message.warning('当前评审步骤不是暗标，不能查看对照表格')
          }
        } else {
          this.$message.error(res.msg || '获取暗标状态失败')
        }
      } catch (e) {
        console.error('获取暗标状态失败', e)
        this.$message.error('获取暗标状态失败')
      } finally {
        this.compareTableLoading = false
      }
    },

    async loadComparisonTable() {
      const params = {
        sectionCode: this.finalBidSectionCode,
        stepId: this.currentStep.id
      }
      const res = await realTimeReviewApi.getComparisonTable(params)
      if (res.code === 200) {
        const data = res.data || []
        this.comparisonTableData = Array.isArray(data) ? data : []
        this.compareTableDialogVisible = true
      } else {
        this.$message.error(res.msg || '获取对照表格失败')
      }
    },
    /**
     * 打印
     */
    handlePrint() {
      const printContent = this.$refs.printArea.innerHTML
      if (!printContent) {
        this.$message.warning('暂无可打印的内容')
        return
      }
      const iframe = document.createElement('iframe')
      iframe.style.position = 'absolute'
      iframe.style.width = '0px'
      iframe.style.height = '0px'
      iframe.style.border = 'none'
      document.body.appendChild(iframe)
      const doc = iframe.contentDocument || iframe.contentWindow.document
      doc.write(`
            <html>
            <head>
            <title>评审结果打印</title>
            </head>
            <body>
            ${printContent}
            </body>
            </html>
      `)
      doc.close()
      setTimeout(() => {
        iframe.contentWindow.print()
        document.body.removeChild(iframe)
      }, 3000)
    },
    /**
     * 返回上一页
     */
    handleBack() {
      this.$router.go(-1)
    },
    /**
     * 切换左侧面板展开/折叠
     */
    toggleLeftPanel() {
      this.isLeftPanelCollapsed = !this.isLeftPanelCollapsed
    },
  }
}
</script>


<style scoped>
/* 基础重置与布局 */
.real-time-review {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
}

.page-header {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  z-index: 10;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-left i {
  font-size: 24px;
  color: #409eff;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.header-sub {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.live-tag {
  margin-left: 12px;
}

.main-layout {
  flex: 1;
  display: flex;
  overflow: hidden;
  padding: 16px;
  gap: 16px;
}

.left-panel {
  width: 280px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
  position: relative;
  transition: width 0.3s ease;
}

/* 折叠状态 */
.left-panel.collapsed {
  width: 30px;
}

.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
}

/* 卡片通用样式 */
.panel-card {
  background: #fff;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.panel-title {
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  background: #fafafa;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  position: relative;
}

/* 标题中的折叠图标 */
.collapse-icon {
  font-size: 16px;
  color: #909399;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 4px;
  border-radius: 4px;
}

.collapse-icon:hover {
  color: #409eff;
  background: #ecf5ff;
}

/* 拖拽调整手柄 */
.resize-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 24px;
  cursor: ns-resize;
  color: #909399;
  transition: all 0.3s ease;
  border-radius: 4px;
}

.resize-handle:hover {
  color: #409eff;
  background: #ecf5ff;
}

.resize-handle i {
  font-size: 14px;
}

.panel-body {
  padding: 16px;
}

/* 折叠状态下的展开按钮 */
.collapsed-expand-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.collapsed-expand-btn:hover {
  background: #f5f7fa;
  border-color: #409eff;
  color: #409eff;
}

.collapsed-expand-btn i {
  font-size: 16px;
  color: #606266;
  transition: color 0.3s ease;
}

.collapsed-expand-btn:hover i {
  color: #409eff;
}

/* 步骤列表卡片 */
.step-list-card {
  flex: 1;
  min-height: 0;
}

.step-list-scroll {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

/* 步骤列表 */
.step-list {
  /* 移除原有的 overflow 相关样式 */
}

.step-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f2f6fc;
  transition: background 0.2s;
}

.step-item:hover {
  background: #f5f7fa;
}

.step-item.active {
  background: #ecf5ff;
  border-left: 3px solid #409eff;
}

.step-index {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e4e7ed;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.step-item.active .step-index {
  background: #409eff;
}

.step-info {
  flex: 1;
  min-width: 0;
}

.step-name {
  font-size: 13px;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.step-type {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.step-status {
  margin-left: 8px;
}

/* 控制栏 */
.control-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.control-label {
  font-size: 13px;
  color: #606266;
}

.status-indicator {
  font-size: 12px;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 专家列表 */
.expert-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.expert-item {
  padding: 8px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #606266;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.expert-item:hover {
  border-color: #c6e2ff;
  color: #409eff;
}

.expert-item.active {
  background: #ecf5ff;
  border-color: #409eff;
  color: #409eff;
}

/* 评审详情卡片 */
.detail-card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* 底部拖拽条 */
.resize-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 6px;
  cursor: ns-resize;
  background: transparent;
  z-index: 100;
  transition: background 0.2s ease;
}

.resize-bar:hover,
.resize-bar:active {
  background: #409eff;
}

.resize-bar::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 3px;
  background: #dcdfe6;
  border-radius: 2px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.resize-bar:hover::before {
  opacity: 1;
}

.detail-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 同时接管横向和纵向滚动，确保滚动条始终贴合容器底部 */
.detail-content-scroll {
  flex: 1;
  overflow: auto;
  min-height: 0;
  padding: 0 16px;
}

/* 覆盖后端 HTML 中包裹表格的 div 的内联样式，防止其独立产生横向滚动条导致位置靠下 */
.detail-content-scroll ::v-deep .html-content > div {
  overflow-x: visible !important;
  width: 100% !important;
}

/* 表格与内容 */
.compact-table {
  width: 100%;
}

.text-ellipsis {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.score-text {
  font-weight: 500;
}

.score-value {
  font-size: 14px;
  color: #303133;
}

.summary-score {
  color: #409eff;
  font-weight: bold;
}

.html-preview,
.html-content {
  font-size: 13px;
  line-height: 1.6;
  color: #606266;
}

.html-content ::v-deep table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px; /* 保证表格足够宽以触发横向滚动 */
}

.html-content ::v-deep th,
.html-content ::v-deep td {
  padding: 8px;
  border: 1px solid #ebeef5;
}

.html-content ::v-deep th {
  background: #fafafa;
}

.empty-tip {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}

.empty-tip i {
  font-size: 32px;
  margin-bottom: 8px;
  display: block;
  color: #c0c4cc;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

/* 响应式微调 */
@media (max-width: 1200px) {
  .left-panel {
    width: 280px;
  }

  .left-panel.collapsed {
    width: 40px;
  }
}
</style>
